import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { Flex, LabelXSmall } from '../../../../../primitives/index.js';
const getFlagEmoji = countryCode => {
  const formattedCountryCode = countryCode === 'en' ? 'gb' : countryCode;
  const codePoints = formattedCountryCode.toUpperCase().split('').map(char => 127_397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
};
export const UserAge = ({
  age,
  language,
  nationality
}) => {
  const {
    t
  } = useTranslation('hotelDetailsOverlay');
  return _jsxs(Flex, {
    alignItems: "center",
    spacing: "8px",
    direction: "row",
    children: [_jsx(LabelXSmall, {
      color: "contentSecondary",
      children: t('amadeusRatingSection.reviewItem.age', {
        age: age.replace('70-', '70+') // temporary solution, will be removed after fixing Amadeus service
      })
    }),
    // DACH reviews have no nationality, CEE ones have both
    getFlagEmoji(nationality || language)]
  });
};